import {
  computed, ComputedRef, reactive, ref,
} from 'vue';

import { PositionType } from '@/types/place.type';

interface CurrentPositionStorageType extends PositionType {
  status: boolean;
}
type useUserLocationType = {
  currentPositionStorage: ComputedRef<CurrentPositionStorageType>;
  currentPosition: CurrentPositionStorageType;
  askUserLocation: () => void;
  updateUserLocationByInput: (lng: number, lat: number) => void
}
const currentPosition = reactive({
  lat: ref<number>(-36.8472123064016),
  lng: ref<number>(174.7613830367111),
  status: true,
});
export default function useUserLocation(): useUserLocationType {
  const defaultPosition = { lat: -36.8472123064016, lng: 174.7613830367111 };
  const currentPositionStorage = computed<CurrentPositionStorageType>(() => currentPosition);
  const askUserLocation = () => {
    if (navigator) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          currentPosition.lat = pos.coords.latitude;
          currentPosition.lng = pos.coords.longitude;
        },
        (error) => {
          currentPosition.status = false;
          currentPosition.lat = defaultPosition.lat;
          currentPosition.lng = defaultPosition.lng;
          console.log(error.message);
        },
      );
    }
  };
  return {
    currentPositionStorage,
    currentPosition,
    askUserLocation,
    updateUserLocationByInput: (lat: number, lng: number) => {
      currentPosition.lat = lat;
      currentPosition.lng = lng;
      console.log(currentPositionStorage);
    },
  };
}
